export default __webpack_public_path__ + "static/media/fun-card-bg.0c84c3c2.png";